(function (overtimeDeclaration, $) {
    var editMode = false;

    overtimeDeclaration.modes = [
        { index: "Allowance", title: 'Toeslag uitbetalen' },
        { index: "AllowanceAndHours", title: 'Volledig uitbetalen' },
        { index: "Hours", title: 'Verlof' }
    ];

    overtimeDeclaration.Init = function () {
        editMode = true;

        $(document).on("change", "[data-book-absence]", function (evt) {
            if ($("#book-absence-yes").prop('checked'))
                $("[data-absence-type-container]").show();
            if ($("#book-absence-no").prop('checked')) {
                $("[data-absence-type-container]").hide();
                $("[data-hidden-absence-code]").val(undefined);
            }
        });

        $(document).on("change", "[data-book-project]", function (evt) {
            if ($("#book-project-yes").prop('checked')) {
                $("[data-all-projects-container]").show();
            }
            if ($("#book-project-no").prop('checked')) {
                $("#all-projects-no").prop('checked', true)
                $("[data-all-projects-container]").hide();
            }
        });

        $(document).on("change", "[data-absence-type]", function (evt) {
            $('[data-hidden-absence-code]').val($(this).find(':selected').val());
        });
    }

    //Remove operators from number input fields (+, -, e, ., .)
    overtimeDeclaration.CheckNumberOnly = function () {
        $('[data-numbersonly="true"]').attr("onkeydown", "return event.keyCode !== 69 && event.keyCode !== 109 && event.keyCode !== 107 && event.keyCode !== 190 && event.keyCode !== 110")
    }

    /* round time to nearest 15 minutes */
    overtimeDeclaration.initRoundTime = function () {
        $(document).on('change', "[data-roundtime]", function () {
            /* 1000 milliseconds * 60 seconds * 15 minutes = 15 minutes in milliseconds */
            const ms = 1000 * 60 * 15;
            /* get time from time input */
            let hours = $(this).val().substring(0, 2);
            let minutes = $(this).val().substring(3, 5);
            let timems = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);

            let datetime = new Date('July 1, 1999, 00:00');
            let actualTime = new Date();

            actualTime.setTime(datetime.getTime() + timems);
            let roundedTime = new Date(Math.round(actualTime.getTime() / ms) * ms);
            let hourString = roundedTime.getHours().toString().padStart(2, '0');
            let minuteString = roundedTime.getMinutes().toString().padStart(2, '0');
            $(this).val(`${hourString}:${minuteString}`);

            if ($("input#StartTime").val() !== '00:00' || $("input#EndTime").val() !== '00:00')
                $("input#EntireDay2").prop("checked", true);
            else
                $("input#EntireDay1").prop("checked", true);
        });
    }

    overtimeDeclaration.initDeclarationResultModal = function () {
        $("[data-declarationResultModalButton]").on("click", function () {
            var modalData = $(this).next("[data-declarationResultModal]");
            $("#modalcontainer .modal-content").html(modalData.html());
            $("#modalcontainer").modal('show');
            $("#modal fade").attr("class", "second");
        });
    }

    overtimeDeclaration.setTimeInputs = function () {
        let entireDay = $("input#EntireDay1").prop("checked");
        if (!editMode) {
            let startTimeContainer = $("div.row.mb-3:has(input#StartTime)");
            let endTimeContainer = $("div.row.mb-3:has(input#EndTime)");

            if (entireDay) {
                $("input#StartTime").val("00:00");
                $("input#EndTime").val("00:00");
                startTimeContainer.hide();
                endTimeContainer.hide();
            }
            else {
                startTimeContainer.show();
                endTimeContainer.show();
            }
        }
    }

    overtimeDeclaration.initCalculationrule = function () {
        overtimeDeclaration.initRoundTime();
        overtimeDeclaration.CheckNumberOnly();
        globalCore.EnablePopOver();

        // Allow JQuery Validator to see comma as the seperator versus notation
        global.EnableJQueryValidatorLocalized();

        $("input[name=EntireDay]").on("change", (e) => {
            overtimeDeclaration.setTimeInputs;
            $('#starttime').toggle();
            $('#endtime').toggle();
        });
    }

    overtimeDeclaration.InitDeclarationTypeGrid = function (subscriptionKey, integrationUrl) {
        $('#declarationTypeGrid').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/overtimedeclaration/SearchDeclarationTypes?subscriptionKey=${subscriptionKey}`
            },
            columns: [
                { data: "name", name: "Name", title: "Naam", orderable: true, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: -1,
                    width: '275px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `
                            <a class="btn btn-datatable btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/OvertimeDeclaration/DeleteDeclarationType?subscriptionKey=${globalCore.urlEncode(subscriptionKey)}&declarationTypeKey=${globalCore.urlEncode(full.key)}" data-bs-toggle="modal" data-bs-target="#modalcontainer"></a>
                            <a class="btn btn-datatable btn-outline-primary fas fa-edit" title="Wijzigen" href="/OvertimeDeclaration/EditDeclarationType?subscriptionKey=${globalCore.urlEncode(subscriptionKey)}&declarationTypeKey=${globalCore.urlEncode(full.key)}" data-bs-toggle="modal" data-bs-target="#modalcontainer"></a>
                            <a class="btn btn-datatable btn-outline-primary fa-solid fas fa-list" title="Rekenregels" href="/OvertimeDeclaration/DetailsDeclarationType?subscriptionKey=${globalCore.urlEncode(subscriptionKey)}&declarationTypeKey=${globalCore.urlEncode(full.key)}"></a>
                            <a class="btn btn-datatable btn-outline-primary btn-copy-declaration-type fa-solid fas fa-copy" title="Declaratiesoort kopiëren" href="/OvertimeDeclaration/CopyDeclarationType?subscriptionKey=${globalCore.urlEncode(subscriptionKey)}&declarationTypeKey=${globalCore.urlEncode(full.key)}" data-ajax="true" data-ajax-method="POST" data-ajax-success="location.reload()"></a>
                            <button type="button" class="btn btn-datatable btn-outline-primary fas fa-link" title="Declaratie URL kopiëren" data-content="URL gekopieerd" data-copytoclipboard="${integrationUrl}/OvertimeDeclaration?declarationTypeKey=${globalCore.urlEncode(full.key)}"></button>`;
                    }
                }
            ]
        }));
    }

    overtimeDeclaration.InitCalculationRuleGrid = function (subscriptionKey, declarationTypeKey) {
        const holidayIndex = 7;
        const dayAfterHolidayIndex = 8;
        const percentageIndex = 11;

        $('#calculationRuleGrid').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: `/overtimedeclaration/SearchCalculationRules?subscriptionKey=${subscriptionKey}&declarationTypeKey=${declarationTypeKey}`
            },
            order: [[ percentageIndex, 'asc' ]],
            columns: [
                // Day columns cannot be mapped
                { title: "Ma", defaultContent: "", orderable: false, searchable: false }, // 0, Monday
                { title: "Di", defaultContent: "", orderable: false, searchable: false }, // 1, Tuesday
                { title: "Wo", defaultContent: "", orderable: false, searchable: false }, // 2, Wednesday
                { title: "Do", defaultContent: "", orderable: false, searchable: false }, // 3, Thursday
                { title: "Vr", defaultContent: "", orderable: false, searchable: false }, // 4, Friday
                { title: "Za", defaultContent: "", orderable: false, searchable: false }, // 5, Saturday
                { title: "Zo", defaultContent: "", orderable: false, searchable: false }, // 6 Sunday
                { data: "holiday", name: "Holiday", title: "Feestdag", orderable: false, searchable: false },
                { data: "dayAfterHoliday", name: "DayAfterHoliday", title: "Dag na feestdag", orderable: false, searchable: false },
                { data: "startTime", name: "StartTime", title: "Begintijd", orderable: false, searchable: false },
                { data: "endTime", name: "EndTime", title: "Eindtijd", orderable: false, searchable: false },
                { data: "percentage", name: "Percentage", title: "Percentage", orderable: true, searchable: false },
                { data: "salaryCode", name: "SalaryCode", title: "Looncode toeslag uitbetalen", orderable: false, searchable: false },
                { data: "salaryCodeAllowanceAndHours", name: "SalaryCodeAllowanceAndHours", title: "Looncode volledig uitbetalen", orderable: false, searchable: false },
                { responsivePriority: -1, defaultContent: "", orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1, 2, 3, 4, 5, 6],
                    className: 'text-center',
                    width: '50px',
                    fixed: true,
                    render: function(data, type, full, meta) {
                        return `<input class="form-check-input" type="checkbox" disabled="disabled" ${overtimeDeclaration.DayIsSelected(full.days, meta.col) === true ? "checked" : null} />`;
                    }
                },
                {
                    targets: holidayIndex,
                    className: 'text-center',
                    width: '75px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `<input class="form-check-input" type="checkbox" disabled="disabled" ${full.holiday === true ? "checked" : null} />`;
                    }
                },
                {
                    targets: dayAfterHolidayIndex,
                    className: 'text-center',
                    width: '125px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return`<input class="form-check-input" type="checkbox" disabled="disabled" ${full.dayAfterHoliday === true ? "checked" : null} />`;
                    }
                },
                {
                    targets: [9, 10],
                    className: 'text-center',
                    render: function(data, type, full, meta) {
                        return moment.utc(moment.duration(data).asMilliseconds()).format("HH:mm");
                    }
                },
                {
                    targets: [11],
                    className: 'text-center',
                    render: function(data, type, full, meta) {
                        return `${data}%`
                    }
                },
                {
                    targets: -1,
                    className: 'text-end',
                    width: '125px',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        return `
                            <a class="btn btn-outline-primary fas fa-edit" title="Wijzigen" href="/OvertimeDeclaration/EditCalculationRule?subscriptionKey=${globalCore.urlEncode(subscriptionKey)}&declarationTypeKey=${globalCore.urlEncode(declarationTypeKey)}&calculationRuleKey=${globalCore.urlEncode(full.key)}"></a>
                            <a class="btn btn-outline-primary fas fa-trash-alt" title="Verwijderen" href="/OvertimeDeclaration/DeleteCalculationRule?subscriptionKey=${globalCore.urlEncode(subscriptionKey)}&declarationTypeKey=${globalCore.urlEncode(declarationTypeKey)}&calculationRuleKey=${globalCore.urlEncode(full.key)}"></a>`;
                    }
                }
            ]
        }));
    }

    overtimeDeclaration.initDeclarationRulesTable = function (declarationRequestKey) {
        var table = $('#declarationrulestable').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: '/OvertimeDeclaration/SearchDeclarationRules',
                data: {
                    declarationRequestKey: declarationRequestKey
                }
            },
            orderFixed: {
                name: 'start',
                dir: 'asc'
            },
            searchable: false,
            info: false,
            paging: false,
            columns: [
                { data: 'start', name: 'Start', title: 'Begin', sortable: true, searchable: false },
                { data: 'end', name: 'End', title: 'Eind', sortable: false, searchable: false },
                { data: 'mode', name: 'Mode', title: 'Soort vergoeding', sortable: false, searchable: false, enum: overtimeDeclaration.modes },
                { data: 'reason', name: 'Reason', title: 'Reden', sortable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1],
                    width: '25%',
                    render: function (data, type, full, meta) {
                        return datatable.dutchDateFormat(data, 'DD-MM-YYYY HH:mm')
                    }
                },
                {
                    targets: [2],
                    width: '25%'
                },
                {
                    targets: [3],
                    width: '25%',
                    render: function (data, type, full, meta) {
                        return !data || data === null ? '' : data;
                    }
                }
            ]
        }));
    }

    overtimeDeclaration.initDeclarationResultsTable = function (subscriptionKey, declarationRequestKey) {
        var bindOnClicks = function () {
            $('[data-declarationResultModalButton]').on('click', function () {
                var modalData = $(this).next('[data-declarationResultModal]');
                $('#modalcontainer .modal-content').html(modalData.html());
                $('#modalcontainer').modal('show');
                $('#modal fade').attr('class', 'second');
            });
        };

        var table = $('#declarationresultstable').DataTable(datatable.defaultDataTableOptions({
            ajax: {
                url: '/OvertimeDeclaration/SearchDeclarationResults',
                data: {
                    subscriptionKey: subscriptionKey,
                    declarationRequestKey: declarationRequestKey
                }
            },
            searchable: false,
            info: false,
            paging: false,
            columns: [
                { data: 'displayTotalDuration', name: 'DisplayTotalDuration', title: 'Aantal uren', sortable: true, searchable: false },
                { data: 'mode', name: 'Mode', title: 'Soort vergoeding', sortable: false, searchable: false, enum: overtimeDeclaration.modes },
                { data: 'displayPercentage', name: 'DisplayPercentage', title: 'Percentage', sortable: false, searchable: false },
                { data: 'displayLeave', name: 'DisplayLeave', title: 'Verlof', sortable: false, searchable: false },
                { data: 'displayPaidOut', name: 'DisplayPaidOut', title: 'Uitbetalen', sortable: false, searchable: false },
                { responsivePriority: -1, defaultContent: '', orderable: false, searchable: false }
            ],
            columnDefs: [
                {
                    targets: [0, 1, 3, 4],
                    width: '20%'
                },
                {
                    targets: 2,
                    width: '20%',
                    render: function (data, type, full, meta) {
                        return `${data}%`;
                    }
                },
                {
                    target: -1,
                    width: '10%',
                    fixed: true,
                    render: function (data, type, full, meta) {
                        let template = document.getElementById('declaration-result-modal-template');
                        let modal = template.content.cloneNode(true);
                        template = document.getElementById('declaration-result-row-template');
                        let tbody = modal.querySelector('tbody');

                        full.results.forEach((result) => {
                            let createTd = function (node) {
                                let td = document.createElement('td');
                                td.append(node);
                                tr.appendChild(td);
                            }

                            let row = template.content.cloneNode(true);
                            let tr = row.querySelector('tr');
                            createTd(datatable.dutchDateFormat(result.start, 'DD-MM-YYYY'));
                            createTd(datatable.dutchDateFormat(result.start, 'HH:mm'));
                            createTd(datatable.dutchDateFormat(result.end, 'HH:mm'));
                            createTd(result.displayDuration);
                            createTd(overtimeDeclaration.modes.find(mode => mode.index === full.mode).title);
                            createTd(`${full.displayPercentage}%`);
                            createTd(full.displayLeave);
                            createTd(full.displayPaidOut);
                            tbody.appendChild(row);
                        });
                        let button = document.createElement('button');
                        button.classList.add('btn', 'btn-datatable', 'btn-primary');
                        button.setAttribute('type', 'button');
                        button.setAttribute('data-declarationResultModalButton', '');
                        button.innerHTML = 'Details';
                        let div = document.createElement('div');
                        div.setAttribute('hidden', '');
                        div.setAttribute('data-declarationresultmodal', '');
                        div.setAttribute('data-manualmodal', '');
                        div.appendChild(modal);
                        return `${button.outerHTML}\n${div.outerHTML}`;
                    }
                }
            ]
        }));

        table.on('draw', function () {
            $('button[type=\'submit\'][name=\'Action\']').prop('disabled', table.rows().count() == 0);

            bindOnClicks();
        });
    }

    overtimeDeclaration.DayIsSelected = function (days, col) {
        switch(col) {
            case 0: return days.some(item => item.day === "Monday");
            case 1: return days.some(item => item.day === "Tuesday");
            case 2: return days.some(item => item.day === "Wednesday");
            case 3: return days.some(item => item.day === "Thursday");
            case 4: return days.some(item => item.day === "Friday");
            case 5: return days.some(item => item.day === "Saturday");
            case 6: return days.some(item => item.day === "Sunday");

            default: return false;
        }
    }

}(window.overtimeDeclaration = window.overtimeDeclaration || {}, $));
